const UNSET_CITY = '未设置城市'

function compareChinese(left, right) {
  return String(left || '').localeCompare(String(right || ''), 'zh-Hans-CN', {
    numeric: true,
    sensitivity: 'base'
  })
}

export function getStoreCity(store) {
  const city = store && typeof store.city === 'string' ? store.city.trim() : ''
  return city || UNSET_CITY
}

export function formatStoreLabel(store, includeCity = true) {
  if (!store) return '未知门店'
  const name = String(store.storeName || '未命名门店').trim()
  const code = String(store.storeCode || '').trim()
  const nameWithCode = code ? `${name}（${code}）` : name
  return includeCity ? `${getStoreCity(store)} · ${nameWithCode}` : nameWithCode
}

export function groupStoresByCity(stores) {
  const groups = new Map()
  ;(Array.isArray(stores) ? stores : []).forEach(store => {
    const city = getStoreCity(store)
    if (!groups.has(city)) groups.set(city, [])
    groups.get(city).push(store)
  })

  return Array.from(groups.entries())
    .map(([city, cityStores]) => ({
      city,
      stores: cityStores.slice().sort((left, right) => {
        const nameCompare = compareChinese(left && left.storeName, right && right.storeName)
        if (nameCompare !== 0) return nameCompare
        const codeCompare = compareChinese(left && left.storeCode, right && right.storeCode)
        if (codeCompare !== 0) return codeCompare
        return Number(left && left.id) - Number(right && right.id)
      })
    }))
    .sort((left, right) => {
      if (left.city === UNSET_CITY) return 1
      if (right.city === UNSET_CITY) return -1
      return compareChinese(left.city, right.city)
    })
}
